import ReactGA from 'react-ga4';

type EventPayload = {
	action: string;
	category: string;
	label?: string;
	value?: number;
	nonInteraction?: boolean;
	transport?: 'beacon' | 'xhr' | 'image';
};

type PageViewPayload = {
	hitType?: 'pageview' | 'redirect';
	page: string;
	title: string;
	value?: string;
};

export const useAnalyticsEventTracker = () => {
	const eventTracker = (eventPayload: EventPayload) => {
		ReactGA.event({
			nonInteraction: true,
			transport: 'beacon',
			...eventPayload,
		});
	};

	const pageViewTracker = (pageViewPayload: PageViewPayload) => {
		ReactGA.send({ hitType: 'pageview', ...pageViewPayload });
	};
	return { eventTracker, pageViewTracker };
};
